import { useCurrentContext } from './useCurrentContext';

/**
 * Hook to get current navigation context (tenant/realm) for team navigation.
 *
 * Context is resolved in priority order:
 * 1. URL query params (tenant, realmId) - highest priority, maintains navigation context
 * 2. Auth defaults (tenant/realm set at login) - fallback
 *
 * This ensures breadcrumbs and API calls use the correct context regardless of
 * where the user navigates from.
 *
 * @example
 * ```tsx
 * const { tenant, realmId } = useNavigationContext();
 * navigateToTeamProfile({ teamId: 123, tenant, realmId });
 * ```
 *
 * @see useCurrentContext - The underlying implementation
 * @see useAppNavigation - Uses this hook internally for automatic context
 * @see src/utils/url.ts - URL builders that accept tenant/realmId
 */
const useNavigationContext = () => {
  const { tenant, realmId } = useCurrentContext();

  return {
    tenant,
    realmId,
  };
};

export default useNavigationContext;
